export const btnList = [
  { text: "打印本页勾选", eventName: 'print_select' },
  { text: "打印全部", eventName: 'print_all' },
]

export const searchList = [
  {
    prop: 'searchType', type: 'select', attrs: { placeholder: '', width: '140px' }, items: [
      { label: '唯一码', value: 'weiyima' },
      { label: '流水号', value: 'lsh' }
    ]
  },
  {
    prop: 'content',
    type: 'input',
    attrs: {
      placeholder: '请输入唯一码/流水号',
    },
  },
]
export const colList = (unvisibleList = []) => {
  const list = [
    { prop: 'picture', attrs: { label: '图片' }, slot: true },
    { prop: 'skuOuterId', attrs: { label: '商品编码' } },
    { prop: 'code', attrs: { label: '唯一码', slot: true } },
    { prop: 'num', attrs: { label: '打印次数' } }
  ]
  return list.filter(item => !unvisibleList.includes(item.prop));
}
